import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Container,
} from 'reactstrap';

import AdminPanelHeader from '../../components/AdminPanel/Header';
import AdminPanelOverview from './Overview';

const AdminPanelDashboard = ({ profile }) => {
  if (!profile) {
    return null;
  }

  return (
    <div className="main-content dashboard-content split-content">
      <div className="split-content-wrapper">
        <Container fluid>
          <AdminPanelHeader
            profile={profile}
          />
          <div className="content-wrapper admin-panel-wrapper admin-dashboard-wrapper dashboard-wrapper">
            <AdminPanelOverview period="all" />
          </div>
        </Container>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

AdminPanelDashboard.propTypes = {
  profile: PropTypes.object,
};

AdminPanelDashboard.defaultProps = {
  profile: null,
};

export default connect(mapStateToProps)(AdminPanelDashboard);
